/**
 * Extracts the activity ID from the current URL.
 *
 * @returns {string} The extracted activity ID if present, otherwise an empty string.
 */
export const getActivityId = (): string => {
  const matched = location.pathname.match(/discounts\/(\w+)\//)
  return matched ? matched[1] : ''
}
